import React from "react";
import { Helmet } from "react-helmet";

const Meta_components = () => {
  return (
    <>
      <Helmet>
        <title>Bazar Wala</title>

        <meta
          name="description"
          content="Your family deserves better. Say goodbye to cold-stored veggies. Get handpicked, same-day fresh fruits & vegetables — hygienic, honest, straight from farm to kitchen."
        />
      </Helmet>
    </>
  );
};

export default Meta_components;
